// extracted by mini-css-extract-plugin
export var $animation_name = "Tab-module--$animation_name--18565";
export var Tab__listItem = "Tab-module--Tab__listItem--64dd8";
export var Tab__listItem___active = "Tab-module--Tab__listItem___active--9406e";
export var Tab__listItem___inActive = "Tab-module--Tab__listItem___inActive--52564";